import { css } from "styled-system/css";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FadeIn } from "@/components/ui/animated";
import { displayApiError } from "@/lib/client-safe-error";

export function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") ?? "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (pw.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (pw !== pw2) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    if (!token.trim()) {
      setError("Enlace inválido.");
      return;
    }
    setBusy(true);
    const r = await fetch("/api/auth/reset-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: token.trim(), password: pw }),
    });
    setBusy(false);
    const j = (await r.json().catch(() => ({}))) as { error?: string };
    if (!r.ok) {
      setError(displayApiError(j.error, "No se pudo actualizar la contraseña."));
      return;
    }
    // El backend ya creó la sesión — ir directo al dashboard
    navigate("/dashboard", { replace: true });
  }

  return (
    <main className={css({ minH: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bg: "#f4f6f8", p: "6" })}>
      <FadeIn>
        <div
          className={css({
            w: "100%",
            maxW: "420px",
            bg: "white",
            rounded: "xl",
            borderWidth: "1px",
            borderColor: "#e2e8f0",
            p: "8",
            boxShadow: "0 12px 40px rgba(15,23,42,0.06)",
          })}
        >
          <h1 className={css({ fontSize: "xl", fontWeight: "bold", color: "#0f172a", mb: "2" })}>Nueva contraseña</h1>
          <p className={css({ fontSize: "sm", color: "#64748b", mb: "6" })}>Elegí una contraseña segura para tu cuenta.</p>
          <form onSubmit={(ev) => void onSubmit(ev)} className={css({ display: "flex", flexDir: "column", gap: "4" })}>
            <label className={css({ display: "flex", flexDir: "column", gap: "1.5", fontSize: "sm" })}>
              Nueva contraseña
              <input
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className={css({
                  h: "11",
                  px: "3",
                  rounded: "lg",
                  borderWidth: "1px",
                  borderColor: "#dbe2ea",
                  fontSize: "sm",
                })}
              />
            </label>
            <label className={css({ display: "flex", flexDir: "column", gap: "1.5", fontSize: "sm" })}>
              Repetir contraseña
              <input
                type="password"
                autoComplete="new-password"
                required
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                className={css({
                  h: "11",
                  px: "3",
                  rounded: "lg",
                  borderWidth: "1px",
                  borderColor: "#dbe2ea",
                  fontSize: "sm",
                })}
              />
            </label>
            {error ? <p className={css({ fontSize: "sm", color: "#b91c1c" })}>{error}</p> : null}
            <button
              type="submit"
              disabled={busy}
              className={css({
                h: "11",
                rounded: "lg",
                fontWeight: "semibold",
                bg: "#0f172a",
                color: "white",
                border: "none",
                cursor: busy ? "wait" : "pointer",
              })}
            >
              {busy ? "Guardando…" : "Guardar contraseña"}
            </button>
          </form>
          <p className={css({ mt: "6", fontSize: "sm", textAlign: "center" })}>
            <Link to="/auth/login" className={css({ color: "#4f46e5", fontWeight: "semibold" })}>
              Ir a iniciar sesión
            </Link>
          </p>
        </div>
      </FadeIn>
    </main>
  );
}
